/**
 * The commit this bundle was built from, inlined at build time (next.config
 * `env`). Empty locally and wherever the build has no commit to name, and an
 * empty value switches the stale-build check off.
 */
export const BUILD_SHA: string = process.env.NEXT_PUBLIC_BUILD_SHA ?? ''

/**
 * A tab is stale when the deployment now serving the site was built from a
 * different commit than the bundle the tab loaded. Either side unknown means
 * no verdict: never prompt on a guess.
 */
export function isStaleBuild({ built, live }: { built: string; live: string }): boolean {
  return built !== '' && live !== '' && built !== live
}
